export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Статус"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сайт"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID магазину"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування магазину"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Платіжне посилання"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активний"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неактивний"])}
}